import styled from 'styled-components';
import Search from '../../components/Search';

export const Root = styled.div`
	padding-top: 50px;
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textM};

	@media (max-width: 992px) {
		padding-top: 10px;
	}
`;

export const Container = styled.div`
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 1430px) {
		max-width: 100%;
		width: 100%;
		box-sizing: border-box;
		margin: 0 auto;
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 40px;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const Title = styled.h1`
	margin: 0;
	color: #000;
	${({ theme }) => theme.typography.headlineXXL};

	@media (max-width: 768px) {
		${({ theme }) => theme.typography.headlineXXLmobile};
	}
`;

export const SearchWrapper = styled.div`
	width: 50%;
	max-width: 480px;

	@media (max-width: 768px) {
		width: 100%;
		max-width: 100%;
	}
`;

export const SearchPanel = styled(Search)`
	input {
		padding-left: 0;
		border-top: none;
		border-right: none;
		border-left: none;
	}
`;

export const Section = styled.div`
	padding: 40px 0 20px 0;
`;

export const List = styled.div`
	margin-bottom: 10px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	margin: 10px 0 70px;
`;
